import { handleActions } from 'redux-actions';

import { DAY_IN_MILLISECONDS } from '../../constants/time';

import * as types from './types';

const initialState = {
  expiry: 0,
  isAuthenticated: false,
  loading: false,
};

const checkSamlAuthRequest = (state) => ({
  ...state,
  loading: true,
});
const checkSamlAuthRequestFailure = (state) => ({
  ...state,
  expiry: 0,
  isAuthenticated: false,
  loading: false,
});
const checkSamlAuthRequestSuccess = (state) => ({
  ...state,
  expiry: Date.now() + DAY_IN_MILLISECONDS,
  isAuthenticated: true,
  loading: false,
});

const logoutSaml = (state) => initialState;

export default handleActions(
  {
    [types.CHECK_SAML_AUTH_REQUEST]: checkSamlAuthRequest,
    [types.CHECK_SAML_AUTH_REQUEST_FAILURE]: checkSamlAuthRequestFailure,
    [types.CHECK_SAML_AUTH_REQUEST_SUCCESS]: checkSamlAuthRequestSuccess,
    [types.LOGOUT_SAML]: logoutSaml,
  },
  initialState
);
